import React, { useState } from "react";
import { FaBars } from "react-icons/fa";

function SiteHeader({ isDarkMode, onToggleTheme }) {
    const [menuOpen, setMenuOpen] = useState(false);

    // Style variables from your home page CSS
    const styles = {
        brandPrimary: "#004080",
        brandAccent: "#ffcc00",
        bgSecondary: "#161b22",
        cardBg: "#1f2630",
        borderColor: isDarkMode ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.1)",
    };

    const navLinkStyle = {
        color: "white",
        textDecoration: "none",
        fontWeight: "bold",
        padding: "6px 15px",
        borderRadius: "6px",
        border: "1px solid transparent",
        transition: "all 0.3s ease",
        display: "block",
        fontSize: "16px",
        fontFamily: "Arial, sans-serif"
    };

    const handleHover = (e, isEntering) => {
        if (isEntering) {
            if (isDarkMode) {
                e.target.style.background = styles.cardBg;
                e.target.style.border = `1px solid ${styles.borderColor}`;
            } else {
                e.target.style.background = styles.brandAccent;
                e.target.style.color = styles.brandPrimary;
                e.target.style.border = `1px solid ${styles.borderColor}`;
            }
        } else {
            e.target.style.background = "transparent";
            e.target.style.color = "white";
            e.target.style.border = "1px solid transparent";
        }
    };

    return (
        <header
            className="site-header"
            style={{
                backgroundColor: isDarkMode ? styles.bgSecondary : styles.brandPrimary,
                borderBottom: `1px solid ${styles.borderColor}`,
                color: "white",
                height: "60px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "0 20px",
                position: "sticky",
                top: 0,
                zIndex: 1000,
                transition: "background-color 0.3s ease",
            }}
        >
            {/* Logo */}
            <a href="https://dominion-financial.ca/index.html" style={{ display: "flex", alignItems: "center" }}>
                <div
                    style={{
                        backgroundImage: "url('https://dominion-financial.ca/images/banner-logo.svg')",
                        width: "320px",
                        height: "60px",
                        backgroundSize: "cover",
                        backgroundRepeat: "no-repeat",
                    }}
                ></div>
            </a>

            {/* Mobile menu icon */}
            <div
                id="mobile-menu-icon"
                onClick={() => setMenuOpen(!menuOpen)}
                style={{ cursor: "pointer", fontSize: "1.8em", color: "white" }}
            >
                <FaBars />
            </div>

            {/* Navigation */}
            <nav id="navMenu">
                <a href="https://dominion-financial.ca/index.html" 
                   style={navLinkStyle} 
                   onMouseEnter={(e) => handleHover(e, true)} 
                   onMouseLeave={(e) => handleHover(e, false)}>
                    Home
                </a>
                <a href="https://dominion-financial.ca/services.html" 
                   style={navLinkStyle} 
                   onMouseEnter={(e) => handleHover(e, true)} 
                   onMouseLeave={(e) => handleHover(e, false)}>
                    Services
                </a>
                <a href="https://dominion-financial.ca/contact.html" 
                   style={navLinkStyle} 
                   onMouseEnter={(e) => handleHover(e, true)} 
                   onMouseLeave={(e) => handleHover(e, false)}>
                    Contact
                </a>
                <a href="https://dominion-financial.ca/register.html" 
                   style={navLinkStyle} 
                   onMouseEnter={(e) => handleHover(e, true)} 
                   onMouseLeave={(e) => handleHover(e, false)}>
                    Register
                </a>
                <a href="https://dominion-financial.ca/login.html" 
                   style={navLinkStyle} 
                   onMouseEnter={(e) => handleHover(e, true)} 
                   onMouseLeave={(e) => handleHover(e, false)}>
                    Members
                </a>

                <button
                    className="theme-toggle"
                    onClick={() => {
                        onToggleTheme();
                        setMenuOpen(false);
                    }}
                    style={{
                        background: "transparent",
                        border: "1px solid rgba(255,255,255,0.3)",
                        color: "white",
                        padding: "8px 10px",
                        borderRadius: "6px",
                        cursor: "pointer",
                        marginLeft: "10px",
                        transition: "all 0.2s ease",
                        fontSize: "14px"
                    }}
                    onMouseEnter={(e) => e.target.style.background = styles.brandPrimary}
                    onMouseLeave={(e) => e.target.style.background = "transparent"}
                >
                    {isDarkMode ? "Light Mode" : "Dark Mode"}
                </button>
            </nav>

            <style dangerouslySetInnerHTML={{ __html: `
                #navMenu { display: flex; gap: 10px; align-items: center; }
                #mobile-menu-icon { display: none; }

                @media (max-width: 1024px) {
                    #mobile-menu-icon { display: block; }
                    #navMenu {
                        display: ${menuOpen ? "flex" : "none"};
                        position: absolute;
                        top: 60px;
                        right: 0;
                        background-color: ${isDarkMode ? styles.bgSecondary : styles.brandPrimary};
                        flex-direction: column;
                        width: 200px;
                        border-radius: 0 0 0 8px;
                        box-shadow: -4px 4px 8px rgba(0,0,0,0.3);
                        padding: 10px 0 15px 0;
                        gap: 0;
                    }
                    #navMenu a { width: 100%; text-align: left; padding: 12px 20px; }
                    .theme-toggle { margin: 15px 20px !important; }
                }
            `}} />
        </header>
    );
}

export default SiteHeader;